import IFinance from '@/models/interfaces/IFinance';
import Finance from '@/models/finance/Finance';
import IFinanceState from './interfaces/finance-state.d';

export default class FinanceState implements IFinanceState {
    public finance: IFinance = new Finance();
}
